export const chainId = new URLSearchParams(window.location.search).get('chainId');
export const orderGuid = new URLSearchParams(window.location.search).get('orderGuid');

let latestSessionStorage = sessionStorage.getItem(`chain:${chainId}`);

export const setStorage = updates => {
    const cache = { ...getStorage(), ...updates };

    latestSessionStorage = JSON.stringify(cache);

    sessionStorage.setItem(`chain:${chainId}`, latestSessionStorage);

    return cache;
};

export const getStorage = () => {
    return JSON.parse(latestSessionStorage) || { chainId, orderGuid };
};

export const clearCache = () => {
    latestSessionStorage = '';
    sessionStorage.removeItem(`chain:${chainId}`);
};

window.addEventListener('beforeunload', function (e) {
    if (latestSessionStorage) sessionStorage.setItem(`chain:${chainId}`, latestSessionStorage);
});
